/**
 * Pages project hostnames have no Worker `/api/*` route. Google sign-in lives on the
 * custom domain (B-0003). Unique `{hash}.…pages.dev` deployment URLs are left alone.
 */

const PAGES_DEV_TO_PUBLIC: Record<string, string> = {
  'inventohub-staging-2pd.pages.dev': 'https://inventohub-staging.ewpok.com',
  'inventohub-production-6nh.pages.dev': 'https://inventohub.ewpok.com',
};

export function bouncePagesDevUrl(location: {
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
}): string | null {
  const origin = PAGES_DEV_TO_PUBLIC[location.hostname.toLowerCase()];
  if (!origin) return null;
  return `${origin}${location.pathname}${location.search}${location.hash}`;
}
